import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a17467d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OCabecalhoPeriodoEntreDatas",
  "data-testid": "OCabecalhoPeriodoEntreDatas"
}
const _hoisted_2 = { class: "OCabecalhoPeriodoEntreDatas__Setas" }
const _hoisted_3 = {
  class: "OCabecalhoPeriodoEntreDatas__Botoes p-buttonset",
  "data-testid": "OCabecalhoPeriodoEntreDatas__Botoes"
}
const _hoisted_4 = { class: "OCabecalhoPeriodoEntreDatas__Periodo" }

import Calendar from "primevue/calendar"
  import Dropdown from "primevue/dropdown"
  import Button from "primevue/button"
  import { computed, ref, watch } from "vue"
  import { usarDataHora } from "@/composable/UsarDataHora/usarDataHora"
  import { useI18n } from "vue-i18n"

  type PeriodoSelecionado = "semana" | "mes" | "personalizado"
  interface Props {
    datasPeriodo: Date[]
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCabecalhoPeriodoEntreDatas',
  props: {
    datasPeriodo: null
  },
  emits: ["update:datasPeriodo"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:datasPeriodo", novasDatas: Date[])
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    datasPeriodo: Date[]
  }

  
  

  const { t } = useI18n()

  const opcoesDePeriodo = [
    { label: t("semana"), valor: "semana" },
    { label: t("mes"), valor: "mes" },
    { label: t("personalizado"), valor: "personalizado" },
  ]

  const {
    pegarDataInicioEFimDaSemana,
    pegarDataInicioEFimDoMes,
    pegarDiferencaEmDiasEntreDatas,
    pegarDataDeAcordoComIntervaloEmDias,
    meses,
  } = usarDataHora()

  const periodoSelecionado = ref<PeriodoSelecionado>("semana")
  const componenteCalendario = ref()

  const datas = computed({
    get() {
      return props.datasPeriodo
    },
    set(novasDatas: Date[]) {
      emitir("update:datasPeriodo", novasDatas)
    },
  })

  const descricaoPeriodoSelecionado = computed(() => {
    const [dataInicio, dataFim] = datas.value
    const legendaDataInicial = dataInicio
      ? `${meses[dataInicio?.getMonth()]} ${dataInicio?.getDate()}`
      : ""
    const legendaDataFinal = dataFim
      ? `- ${meses[dataFim?.getMonth()]} ${dataFim?.getDate()}`
      : ""
    const legendaAno = dataFim ? `, ${dataInicio?.getFullYear()}` : ""

    return `${legendaDataInicial} ${legendaDataFinal}${legendaAno}`
  })

  const definirDatasInicioFimSemana = (data: Date) => {
    const inicioSemana = pegarDataInicioEFimDaSemana(data).inicioDaSemana
    const fimSemana = pegarDataInicioEFimDaSemana(data).fimDaSemana
    datas.value = [inicioSemana, fimSemana]
  }

  const definirDatasInicioFimMes = (data: Date) => {
    const inicioMes = pegarDataInicioEFimDoMes(data).inicioDoMes
    const fimMes = pegarDataInicioEFimDoMes(data).fimDoMes
    datas.value = [inicioMes, fimMes]
  }

  const abrirCalendarioParaSelecaoDePeriodo = () => {
    componenteCalendario.value.onFocus()
  }

  const irParaPeriodoAtual = (): void => {
    if (periodoSelecionado.value === "personalizado") {
      periodoSelecionado.value = "semana"
    }
    definirDataDeAcordoComSelecao(periodoSelecionado.value)
  }

  const definirDataDeAcordoComSelecao = (selecao: PeriodoSelecionado) => {
    switch (selecao) {
      case "semana":
        definirDatasInicioFimSemana(new Date())
        break
      case "mes":
        definirDatasInicioFimMes(new Date())
        break
      case "personalizado":
        abrirCalendarioParaSelecaoDePeriodo()
        break
    }
  }

  const definirDatasParaProximaSemana = (dataInicio: Date, dataFim: Date) => {
    const novoInicio = pegarDataDeAcordoComIntervaloEmDias(dataInicio, 7)
    const novoFim = pegarDataDeAcordoComIntervaloEmDias(dataFim, 7)
    datas.value = [novoInicio, novoFim]
  }

  const definirDatasParaProximoMes = (dataInicio: Date) => {
    const dataReferencia = new Date(dataInicio)
    const dataReferenciaProximoMes = new Date(
      dataReferencia.setMonth(dataReferencia.getMonth() + 1)
    )

    const novoInicioMes = pegarDataInicioEFimDoMes(
      dataReferenciaProximoMes
    ).inicioDoMes
    const novoFimMes = pegarDataInicioEFimDoMes(
      dataReferenciaProximoMes
    ).fimDoMes

    datas.value = [novoInicioMes, novoFimMes]
  }

  const definirDatasParaProximoPersonalizado = (
    dataInicio: Date,
    dataFim: Date
  ) => {
    const dataReferenciaInicio = new Date(dataInicio)
    const dataReferenciaFim = new Date(dataFim)
    const intervalo = pegarDiferencaEmDiasEntreDatas(
      dataReferenciaInicio,
      dataReferenciaFim
    )

    const novoInicioPersonalizado = pegarDataDeAcordoComIntervaloEmDias(
      dataReferenciaFim,
      1
    )
    const novoFimPersonalizado = pegarDataDeAcordoComIntervaloEmDias(
      novoInicioPersonalizado,
      intervalo
    )

    datas.value = [novoInicioPersonalizado, novoFimPersonalizado]
  }

  const mudarProximoPeriodoDeAcordoComSelecao = () => {
    const selecao = periodoSelecionado.value
    const [inicio, fim] = datas.value

    switch (selecao) {
      case "semana":
        definirDatasParaProximaSemana(inicio, fim)
        break
      case "mes":
        definirDatasParaProximoMes(inicio)
        break
      case "personalizado":
        definirDatasParaProximoPersonalizado(inicio, fim)
        break
    }
  }

  const definirDatasParaSemanaAnterior = (dataInicio: Date, dataFim: Date) => {
    const novoInicio = pegarDataDeAcordoComIntervaloEmDias(dataInicio, -7)
    const novoFim = pegarDataDeAcordoComIntervaloEmDias(dataFim, -7)

    datas.value = [novoInicio, novoFim]
  }

  const definirDatasParaMesAnterior = (dataInicio: Date) => {
    const dataReferencia = new Date(dataInicio)
    const dataReferenciaProximoMes = new Date(
      dataReferencia.setMonth(dataReferencia.getMonth() - 1)
    )

    const novoInicioMes = pegarDataInicioEFimDoMes(
      dataReferenciaProximoMes
    ).inicioDoMes
    const novoFimMes = pegarDataInicioEFimDoMes(
      dataReferenciaProximoMes
    ).fimDoMes

    datas.value = [novoInicioMes, novoFimMes]
  }

  const definirDatasParaPersonalizadoAnterior = (
    dataInicio: Date,
    dataFim: Date
  ) => {
    const dataReferenciaInicio = new Date(dataInicio)
    const dataReferenciaFim = new Date(dataFim)
    const intervalo = pegarDiferencaEmDiasEntreDatas(
      dataReferenciaInicio,
      dataReferenciaFim
    )

    const novoFimPersonalizado = pegarDataDeAcordoComIntervaloEmDias(
      dataReferenciaInicio,
      -1
    )
    const novoInicioPersonalizado = pegarDataDeAcordoComIntervaloEmDias(
      novoFimPersonalizado,
      -intervalo
    )

    datas.value = [novoInicioPersonalizado, novoFimPersonalizado]
  }

  const mudarAnteriorPeriodoDeAcordoComSelecao = () => {
    const selecao = periodoSelecionado.value
    const [inicio, fim] = datas.value

    switch (selecao) {
      case "semana":
        definirDatasParaSemanaAnterior(inicio, fim)
        break
      case "mes":
        definirDatasParaMesAnterior(inicio)
        break
      case "personalizado":
        definirDatasParaPersonalizadoAnterior(inicio, fim)
        break
    }
  }

  const checarSePossuiDataInicioEFim = () => {
    const possuiDataInicoEFim = datas.value.every((data) => Boolean(data))
    if (!possuiDataInicoEFim) {
      componenteCalendario.value.onFocus()
    }
  }

  watch(
    datas,
    (datasAtuais) => {
      const [inicio, fim] = datasAtuais

      if (!inicio || !fim) {
        return
      }
      const periodo = periodoSelecionado.value
      const intervalo = pegarDiferencaEmDiasEntreDatas(inicio, fim)
      const intervalosPossivelEmDiasDosMeses = [27, 28, 29, 30]
      if (periodo === "semana" && intervalo !== 6) {
        periodoSelecionado.value = "personalizado"
      }
      if (
        periodo === "mes" &&
        !intervalosPossivelEmDiasDosMeses.includes(intervalo)
      ) {
        periodoSelecionado.value = "personalizado"
      }
    },
    { deep: true }
  )

  definirDataDeAcordoComSelecao(periodoSelecionado.value)

return (_ctx: any,_cache: any) => {
  const _component_PButton = _resolveComponent("PButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_unref(Button), {
          onClick: mudarAnteriorPeriodoDeAcordoComSelecao,
          class: "OCabecalhoPeriodoEntreDatas__Anterior",
          "data-testid": "OCabecalhoPeriodoEntreDatas__Anterior",
          icon: "pi pi-angle-left"
        }),
        _createVNode(_unref(Button), {
          onClick: mudarProximoPeriodoDeAcordoComSelecao,
          class: "OCabecalhoPeriodoEntreDatas__Proxima",
          "data-testid": "OCabecalhoPeriodoEntreDatas__Proxima",
          icon: "pi pi-angle-right",
          "icon-pos": "right"
        })
      ]),
      _createVNode(_component_PButton, {
        onClick: irParaPeriodoAtual,
        class: "OCabecalhoPeriodoEntreDatas__Hoje",
        label: _unref(t)('hoje')
      }, null, 8, ["label"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h1", null, _toDisplayString(_unref(descricaoPeriodoSelecionado)), 1)
    ]),
    _createVNode(_unref(Dropdown), {
      modelValue: periodoSelecionado.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((periodoSelecionado).value = $event)),
      onChange: _cache[1] || (_cache[1] = ($event: any) => (definirDataDeAcordoComSelecao(periodoSelecionado.value))),
      class: "OCabecalhoPeriodoEntreDatas__Dropdown",
      "data-testid": "OCabecalhoPeriodoEntreDatas__Dropdown",
      "option-label": "label",
      "option-value": "valor",
      options: opcoesDePeriodo,
      placeholder: _unref(t)('selecionarPeriodo')
    }, null, 8, ["modelValue", "placeholder"]),
    _createVNode(_unref(Calendar), {
      modelValue: _unref(datas),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(datas) ? (datas).value = $event : null)),
      onHide: checarSePossuiDataInicioEFim,
      ref_key: "componenteCalendario",
      ref: componenteCalendario,
      "hide-on-range-selection": true,
      "input-class": "input_calendario",
      "manual-input": false,
      "selection-mode": "range"
    }, null, 8, ["modelValue"])
  ]))
}
}

})